require(['lazyLoad'], (lazyLoad) => {
  'use strict';

  lazyLoad.init();
});

define("AboutUs", function(){});

